// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  transition: background-color 0.3s ease, -webkit-backdrop-filter 0.3s ease;
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease, -webkit-backdrop-filter 0.3s ease;
}

.header-transparent {
  background-color: transparent !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
  box-shadow: none !important;
}

.credit-btn {
	height: 100%;
	align-self: center;
	cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,yEAAiE;EAAjE,iEAAiE;EAAjE,oGAAiE;AACnE;;AAEA;EACE,wCAAwC;EACxC,wCAAgC;UAAhC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB","sourcesContent":[".header {\n  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;\n}\n\n.header-transparent {\n  background-color: transparent !important;\n  backdrop-filter: none !important;\n  box-shadow: none !important;\n}\n\n.credit-btn {\n\theight: 100%;\n\talign-self: center;\n\tcursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
